var map = {
	"./map-option-jicha.png": "8e58",
	"./map-option-jifang.png": "2d36",
	"./map-option-jigeng.png": "ea6a",
	"./map-option-jihong.png": "a464",
	"./map-option-jishou.png": "9ecd",
	"./map-option-total.png": "0162"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dfd";